import { useState } from "react"
import { Flex, Input, Modal, Form, DatePicker, Dropdown, Button } from "antd"
import { UserOutlined } from '@ant-design/icons'

export const ScheduleModal = ({ program, onSave, onClose }) => {
    const [interval, setInterval] = useState(program.interval ?? 0)
    const handleClose = () => onClose()

    const handleSaveSchedule = () => {
        onSave({ ...program, interval })
        handleClose()
    }
    const handleCancelSchedule = () => handleClose()

    const handleTimeChange = (time) => {
        console.log(time)
        //setSchedule({ ...schedule, time }
    }

    const items = [
        {
            label: '00:00',
            key: '0',
            icon: <UserOutlined />,
        },
        {
            label: '01:00',
            key: '1',
            icon: <UserOutlined />,
        },
        {
            label: '02:00',
            key: '2',
            icon: <UserOutlined />,
        },
        {
            label: '03:00',
            key: '3',
            icon: <UserOutlined />,
        },
        {
            label: '04:00',
            key: '4',
            icon: <UserOutlined />,

        },
        {
            label: '05:00',
            key: '5',
            icon: <UserOutlined />,
        },
        {
            label: '06:00',
            key: '6',
            icon: <UserOutlined />,
        },
        {
            label: '07:00',
            key: '7',
            icon: <UserOutlined />,
        },
        {
            label: '08:00',
            key: '8',
            icon: <UserOutlined />,
        },
        {
            label: '09:00',
            key: '9',
            icon: <UserOutlined />,
        },
        {
            label: '10:00',
            key: '10',
            icon: <UserOutlined />,
        },
        {
            label: '11:00',
            key: '11',
            icon: <UserOutlined />,
        },
        {
            label: '12:00',
            key: '12',
            icon: <UserOutlined />,
        },
        {
            label: '13:00',
            key: '13',
            icon: <UserOutlined />,
        },
        {
            label: '14:00',
            key: '14',
            icon: <UserOutlined />,
        },
        {
            label: '15:00',
            key: '15',
            icon: <UserOutlined />,
        },
        {
            label: '16:00',
            key: '16',
            icon: <UserOutlined />,
        },
        {
            label: '17:00',
            key: '17',
            icon: <UserOutlined />,
        },
        {
            label: '18:00',
            key: '18',
            icon: <UserOutlined />,
        },
        {
            label: '19:00',
            key: '19',
            icon: <UserOutlined />,
        },
        {
            label: '20:00',
            key: '20',
            icon: <UserOutlined />,
        },
        {
            label: '21:00',
            key: '21',
            icon: <UserOutlined />,
        },
        {
            label: '22:00',
            key: '22',
            icon: <UserOutlined />,
        },
        {
            label: '23:00',
            key: '23',
            icon: <UserOutlined />,
        },
    ];

    const handleMenuClick = (e) => {
        program.hourOfDay = parseInt(e.key);

    };

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    const HourToString = [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",

    ];

    return (
        <Modal title="Schema" onOk={handleSaveSchedule} onCancel={handleCancelSchedule} okText="Spara" cancelText="Avbryt" open>
            <Form layout="vertical">
                <Flex justify="space-between" gap="middle" style={{ flexDirection:"column", paddingTop:"40px", paddingBottom:"40px" }}>
                    <div style={{ display: "inline", width: "100%" }}>
                        Välj intervall
                        <Form.Item label="" style={{ width: "50%", float: "right", margin:"0 0 0 0" }}>
                            <Input
                                label="Intervall"
                                suffix="Dagar"
                                type="number"
                                min={0}
                                max={32}
                                defaultValue={interval}
                                onChange={({ target }) => setInterval(target.value)}
                            />
                        
                        </Form.Item>
                    </div>
                    <div style={{ display: "inline", width:"100%", marginTop:"10px" }}>Tid:
                        <Dropdown menu={menuProps} style={{ width: "50%", float: "right"}}>
                            <Button style={{ width: "50%", float: "right"}}>{HourToString[program.hourOfDay]}</Button>
                        </Dropdown>
                    </div>
                    {/* <Form.Item label="Välj tid">
                        <DatePicker.TimePicker onChange={handleTimeChange} format="HH:mm" />
                    </Form.Item> */}
                </Flex>
            </Form>
        </Modal>
    )
}
export default ScheduleModal
